// extracted by mini-css-extract-plugin
export default {"box":"circleStyleTextBox_box__WPc5F","circle":"circleStyleTextBox_circle__356sh"};